import { useEffect, useState } from "react";

/** SSR renders the desktop experience; mobile visitors swap after mount. */
export function useIsMobileVisitor() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, []);
  return isMobile;
}
